'use client';
import { useState, useEffect, useCallback } from 'react';
import React from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Tr, useColorModeValue, useDisclosure } from '@chakra-ui/react';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Thead, Th, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import DynamicFilterall from '../components/DynamicFilterall';
// import {  getCompanies } from '../../../../redux/actions/company';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getReportSaleDetail } from '../../../../redux/actions/reports';
import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { useGlobal } from '../../../../contexts';

const Expense = () => {
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const { companyList } = useGlobal();
   // const company = useSelector((state) => state.company.list);
   // const [compOptions, setCompOptions] = useState(["comp update"]); // Default option

   const dispatch = useDispatch();
   const columnHelper = createColumnHelper();
   const salesReport = useSelector((state) => state.reports?.list || []);
   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsReportsSalesDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const columns = columnsReportsSalesDetail
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color="gray.400">
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      salesReport,
      columns,
      // state: { sorting },
      // onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   useEffect(() => {
      dispatch(getReportSaleDetail());
   }, []);

   // useEffect(() => {
   //   dispatch(getCompanies()); // Fetch companies when the component mounts
   // }, [dispatch]);

   const generateLast40Months = () => {
      const months = [];
      const currentDate = new Date();
      for (let i = 0; i < 40; i++) {
         const year = currentDate.getFullYear();
         const month = currentDate.toLocaleString('en-US', { month: 'short' }); // Example: "Feb"

         months.push(`${month} ${year}`);

         // Move to the previous month
         currentDate.setMonth(currentDate.getMonth() - 1);
      }
      return months;
   };

   // const compOptions = ["comp update", "Long Best Co", "SS WEB CREATION", "TEST COMPANY NAME"];
   const secondOptions = generateLast40Months();
   const ContactBank = ['cash on hand', 'HDFC', 'SBI', 'Madhav packaging'];
   const Category = [
      'Advertisement',
      'ASSETS',
      'Bank charges',
      'Bank charges / Bank charges',
      'Donation',
      'Electricity bill',
      'Entertainment',
      'Food',
      'Fuel',
      'Interest',
      'Internet bill',
      'Legal & professional expense',
      'Mobile bill',
      'Office maintenance',
      'Office maintenance / CREDIT CARD',
      'Office maintenance / Software',
      'Office maintenance / Stationary',
      'Other',
      'Rent',
      'Salary',
      'Shipping',
      'Shipping / TEMPO BHADA EXP',
      'Staff recruitment',
      'Travelling',
      'WITHDRAWAL',
   ];
   const Groupby = ['Category & Account', 'Category & None', 'Account & Category', 'Account & None'];

   const [companyFilter, setcompanyFilter] = useState('');
   const [DateFilter, setDateFilter] = useState('');
   const [ContactBankFilter, setContactBankFilter] = useState('');
   const [CategoryFilter, setCategoryFilter] = useState('');
   const [GroupbyFilter, setGroupbyFilter] = useState('');

   const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');

   const removeFilter = (filterKey) => {
      switch (filterKey) {
         case 'Company':
            setcompanyFilter('');
            break;
         case 'Date':
            setDateFilter('');
            break;
         case 'Contact & Bank':
            setContactBankFilter('');
            break;
         case 'Category':
            setCategoryFilter('');
            break;
         case 'Group by':
            setGroupbyFilter('');
            break;
         default:
            break;
      }
   };

   const [selectedOption, setSelectedOption] = useState('Summary');
   const Dynamicoption = ({ setSelectedOption, selectedOption }) => {
      const options = ['Summary', 'Detail'];

      return (
         <Box bg={backgroundColor} mt="5px" p={2} borderRadius="7px">
            <Table>
               <Thead>
                  <Tr display={'flex'}>
                     {options.map((option, index) => (
                        <Text
                           key={index}
                           borderRadius="full"
                           w={'100%'}
                           py={2}
                           className={selectedOption === option ? 'active' : ''}
                           textAlign="Center"
                           style={{
                              borderTop: '0px',
                              borderRight: '0px',
                              borderLeft: '0px',
                              cursor: 'pointer',
                           }}
                           // onMouseEnter={(e) => {
                           //    e.target.style.backgroundColor = selectedOption === option ? 'transparent' : '#E9FFE9'; // Light blue on hover
                           // }}
                           onMouseLeave={(e) => {
                              e.target.style.backgroundColor =
                                 selectedOption === option ? 'transparent' : 'transparent'; // Reset to original
                           }}
                           onClick={() => setSelectedOption(option)}>
                           <button
                              style={{
                                 fontWeight: '500',
                                 fontSize: '15px',
                              }}>
                              {option}
                           </button>
                        </Text>
                     ))}
                  </Tr>
               </Thead>
            </Table>
         </Box>
      );
   };

   return (
      <>
         {/* Title Outside Card */}

         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="30px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()} // Navigate to the previous page
                  style={{ cursor: 'pointer' }} // Ensure it's clickable
               ></img>
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Expense
               </Text>
            </Flex>

            <Flex>
               <Flex>
                  <Popover>
                     <PopoverTrigger>
                        {/* Image as Clickable Button */}
                        <img src={Download} alt="Download" width="25" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>

                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={() => alert('Option 1 Selected')}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px"></img>
                              Download Execl
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={() => alert('Option 2 Selected')}
                              justifyContent="space-between">
                              <img src={json} alt="Download json" width="30px" mr></img>
                              Download JSON
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
               <Flex ml={5}>
                  <Box>
                     <DynamicFilterall
                        filters={[
                           {
                              name: 'company',
                              options: companyList.map((comp) => comp.name),
                              defaultText: 'Select company',
                              onSelect: (val) => setcompanyFilter(val),
                           },
                           {
                              name: 'Date',
                              options: secondOptions,
                              defaultText: 'Select Date',
                              type: 'date',
                              onSelect: (val) => setDateFilter(val),
                           },
                           {
                              name: 'Contact & Bank',
                              options: ContactBank,
                              defaultText: 'Select Contact & Bank',
                              onSelect: (val) => setContactBankFilter(val),
                           },
                           {
                              name: 'Category',
                              options: Category,
                              defaultText: 'Select Category',
                              isMulti: true,
                              onSelect: (val) => setCategoryFilter(val),
                           },
                           {
                              name: 'Group by',
                              options: Groupby,
                              defaultText: 'Select Group By',
                              onSelect: (val) => setGroupbyFilter(val),
                           },
                        ]}
                     />
                  </Box>
               </Flex>
            </Flex>
         </Flex>

         <Box mt="5px">
            <Grid>
               <Dynamicoption selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
            </Grid>
         </Box>

         <Box bg={backgroundColor} mt="15px" p={3} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2">
               <Flex gap="120px" borderRight="2px solid" paddingRight="30px">
                  <div className="text-center">
                     <Text fontSize={'14px'} fontWeight={500}>
                        Total Amount (₹)
                     </Text>
                     {/* <p className="text-xl font-semibold">{data.length}</p> */}
                     <Text fontSize={'14px'} fontWeight={500}>
                        ₹ 0
                     </Text>
                  </div>
               </Flex>
               {Object.entries({
                  Company: companyFilter,
                  Date: DateFilter,
                  'Contact & Bank': ContactBankFilter,
                  Category: CategoryFilter,
                  'Group by': GroupbyFilter,
               })
                  .filter(([_, value]) => value && value.length > 0) // Ensure it only displays active filters
                  .map(([key, value]) => (
                     <Flex
                        key={key}
                        px={4}
                        py={2}
                        style={{ border: '1px solid', borderRadius: '10px', marginLeft: '10px' }}>
                        <span>{key}</span>
                        <Image
                           src={cancel}
                           alt="Cancel"
                           width={4}
                           ml={5}
                           style={{ cursor: 'pointer' }}
                           onClick={() => removeFilter(key)}
                        />
                     </Flex>
                  ))}
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '65vh', lg: '65vh' }}
                  maxH={{ base: '65vh', lg: '65vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                           <Tr key={headerGroup.id}>
                              {headerGroup.headers.map((header) => (
                                 <Th
                                    // borderRight="1px solid"
                                    borderTop="1px solid"
                                    key={header.id}
                                    colSpan={header.colSpan}
                                    pe="10px"
                                    borderColor={borderColor}
                                    cursor="pointer"
                                    onClick={header.column.getToggleSortingHandler()}>
                                    <Flex
                                       justifyContent="space-between"
                                       align="center"
                                       fontSize={{ sm: '10px', lg: '12px' }}
                                       color="gray.400">
                                       {flexRender(header.column.columnDef.header, header.getContext())}
                                       {{
                                          asc: '↑',
                                          desc: '↓',
                                       }[header.column.getIsSorted()] ?? null}
                                    </Flex>
                                 </Th>
                              ))}
                           </Tr>
                        ))}
                     </Thead>
                     <Tbody>
                        {salesReport.length === 0 ? (
                           <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                              <Td colSpan={columns.length} justifyContent="center" alignItems="center" width="100%">
                                 <Grid justifyContent="center" alignItems="center" gap={9}>
                                    <img
                                       src={nodata} // Replace with actual image URL
                                       alt="No Data Found"
                                       width="200px"
                                       height="200px"
                                    />
                                    <GridItem justifySelf="center">
                                       <label>No Expense data found</label>
                                    </GridItem>
                                 </Grid>
                              </Td>
                           </Tr>
                        ) : (
                           // Render data rows if available
                           salesReport?.map((row, rowIndex) => (
                              <React.Fragment key={row.id}>
                                 <Tr key={row.id} className="editable-row" _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}>
                                    {columns.map((column) => (
                                       <Td
                                          // borderRight="1px solid"
                                          borderColor="gray.200"
                                          key={column.id}
                                          fontSize={{ sm: '14px' }}
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                          // borderColor="transparent"
                                       >
                                          {flexRender(column.cell, {
                                             row,
                                             getValue: () => row[column.id],
                                          })}
                                       </Td>
                                    ))}
                                 </Tr>
                              </React.Fragment>
                           ))
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>
      </>
   );
};

export default Expense;
